import { render, staticRenderFns } from "./AdminResumeUpdate.vue?vue&type=template&id=3f7cc6f2&"
import script from "../../../services/admin/resume/admin-resume-update.js?vue&type=script&lang=js&"
export * from "../../../services/admin/resume/admin-resume-update.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports